export default ["appReducer","cookiesReducer"];
